"use client";

import { FormEvent, useState } from "react";
import Link from "next/link";
import { useParams, useRouter } from "next/navigation";

export default function GuestLoginPage() {
  const params = useParams<{ slug: string }>();
  const router = useRouter();

  const slug = params.slug;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setError(null);
    setIsSaving(true);

    try {
      const apiUrl = process.env.NEXT_PUBLIC_API_URL;

      if (!apiUrl) {
        throw new Error("NEXT_PUBLIC_API_URL is niet ingesteld.");
      }

      const res = await fetch(`${apiUrl}/auth/guest/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_slug: slug,
          email,
          password,
        }),
      });

      if (!res.ok) {
        const message = await res.text().catch(() => "");
        throw new Error(message || `Login mislukt (${res.status})`);
      }

      router.push(`/c/${slug}/rooms`);
      router.refresh();
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Onbekende fout tijdens login"
      );
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <main style={{ padding: 24, maxWidth: 520 }}>
      <h1>Guest login</h1>

      <form
        onSubmit={onSubmit}
        style={{ display: "grid", gap: 12 }}
      >
        <label style={{ display: "grid", gap: 6 }}>
          <span>E-mail</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ padding: 8 }}
          />
        </label>

        <label style={{ display: "grid", gap: 6 }}>
          <span>Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ padding: 8 }}
          />
        </label>

        <button
          type="submit"
          disabled={isSaving}
          style={{ padding: 10 }}
        >
          {isSaving ? "Inloggen…" : "Inloggen"}
        </button>

        {error && <p style={{ color: "crimson" }}>{error}</p>}
      </form>

      <p style={{ marginTop: 20 }}>
        Nog geen account?{" "}
        <Link href={`/c/${slug}/guest/signup`}>
          Account aanmaken
        </Link>
      </p>

      <p>
        <Link href={`/c/${slug}/rooms`}>
          ← Terug naar kamers
        </Link>
      </p>
    </main>
  );
}